import React from "react"
import Prices2 from "../components/prices/prices2"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Pricelist = () => (
  <Layout>
    <SEO title="Pricelist" />
    <Prices2 />
  </Layout>
)

export default Pricelist
